import React from 'react'
import { ResponsiveLine } from '@nivo/line'
import withWidth from '@material-ui/core/withWidth';
import colors from '../../constants/colors'

import {
  format_number
} from '../../helpers'

class Line extends React.Component {
  // props:
  // headers: {h1: {text: "Hi ther", color: "hsl(60, 65%, 50%)"}, {text: "Yello", color: "hsl(216, 70%, 50%)"}}
  // data: server sent it to me :)

  componentDidUpdate(prevProps,prevState) {
    if (prevProps.width !== this.props.width) {
      // console.log( 'New width: ' + this.props.width )
    }
  }

  render() {
    const { headers } = this.props
    const data = this.props.graphData
    // if (data.length === 0) {
    //   return ''
    // }

    const graph_data = Object.keys(headers).map( header => {
      return {
        id: headers[header].text,
        // color: headers[header].color,
        data: data.map( item => {
          return {
            x: item.label,
            y: item[header]
          }
        })
      }
    })


    // const legendOffset = (this.props.width === 'sm' || this.props.width === 'xs') ? 60 : 70
    const legendYOffset = 70
    const legendXOffset = (this.props.width === 'sm' || this.props.width === 'xs') ? -20 : 0
    const rotation = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? -45 : 0

    // const colorMatch = {
    //   'Coupon': '#1d78b4',
    //   'Fully Paid': '#a6cee3',
    //   'Published': '#c6dbef',
    //   'All': '#deebf7',
    //   'Draft': '#deebf7',
    //   'Trashed': '#f7fbff"'
    // }
    const colorMatch = {
      'Coupon': '#9467bd',
      'Fully Paid': '#1f77b4',
      'Published': '#2ea02c',
      'All': '#2ea02c',
      'Draft': '#7f7f7f',
      'Trashed': '#d62728"'
    }

    const tooltip = slice => {
      // custom tooltip with formatted values
      return (
        <table>
          <tbody>
            {slice.data.map(item => {
              const {id, color } = item.serie
              const value = item.data.y
              const useColor = colorMatch[id] || color
              const displayValue = format_number(value, false)
              return (
                <tr key={id}>
                  <td style={{padding: 3}}><span style={{
                    display: 'block', width: 12, height: 12, background: `${useColor} none repeat scroll 0% 0%`
                  }}/></td>
                  <td style={{padding: 3}}>{id}</td>
                  <td style={{padding: 3}}>{displayValue}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )

    }

    return(
      <ResponsiveLine
        tooltip={tooltip}
        data={graph_data}
        enableDots={false}
        colors={colors}
        colorBy={function(e){
          if (e.id === "Coupon") {
            return "#9467bd"
          } else if (e.id === "Fully Paid") {
            return "#1f77b4"
          } else if (e.id === "All" || e.id === "All Tests") {
            return "#2ea02c"
          }
        }}
        xScale={{
          "type": "point"
        }}
        margin={{
          "top": 40,
          "right": 30,
          "bottom": 70,
          "left": 40
        }}
        yScale={{
          "type": "linear",
          "stacked": false,
          "min": "auto",
          "max": "auto"
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          "orient": "bottom",
          "tickSize": 5,
          "tickPadding": 12,
          "tickRotation": rotation,
          "legend": this.props.xaxis || "",
          "legendOffset": 40,
          "legendPosition": "middle"
        }}
        axisLeft={{
          "orient": "left",
          "tickSize": 5,
          "tickPadding": 5,
          "tickRotation": 0,
          "legend": this.props.yaxis || "",
          "legendOffset": -30,
          "legendPosition": "middle"
        }}
        animate={true}
        lineWidth={4}
        motionStiffness={90}
        motionDamping={15}
        theme={{
          axis: {ticks: {text: { fill: "#6A7C89"}}}
        }}
        legends={[{
          "anchor": "bottom-left",
          "direction": "row",
          "justify": false,
          "translateX": legendXOffset,
          "translateY": legendYOffset,
          "itemsSpacing": 0,
          "itemDirection": "left-to-right",
          "itemWidth": 80,
          "itemHeight": 20,
          "itemOpacity": 1,
          "symbolSize": 12,
          "symbolShape": "circle",
          "symbolBorderColor": "rgba(0, 0, 0, .5)",
          "effects": [
            {
              "on": "hover",
              "style": {
                "itemBackground": "rgba(0, 0, 0, .03)",
                "itemOpacity": 1
              }
            }
          ]
        }]}
      />
    )
  }
}

export default withWidth()(Line)



// WEBPACK FOOTER //
// ./src/js/components/graphs/ResponsiveLine.js